import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { Player, BigPlayButton } from 'video-react';
import { useParams } from "react-router-dom";
import Tooltip from '@mui/material/Tooltip';
import { StarIcon } from "../../../SvgIconsData";
import { platformIcon } from "../../../utils/useWindowDimensions";
import { defaultLogo } from "../../../env";
import WindowsIcon from '../../../assets/images/window.png';
import AndroidIcon from '../../../assets/images/playstore.png';
import DesktopVRIcon from '../../../assets/images/standalonevr.png';
import StandaloneVRIcon from '../../../assets/images/meta.png'
import webgl from '../../../assets/images/new/webglnew.svg'
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';


const PlayComp = ({
  moduleDetails,
  availablePlatform,
  isLoggedIn,
  handleSetToAbout,
  average,
  totalReviews,
  courseDuration,
  previewTime,
  video,
  assignedToUser
}) => {

  const params = useParams();
  const iframeRef = useRef(null);
  const moduleUUID = params?.uuid;
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice)
  const [webGlFile, setWebGlFile] = useState("");
  const [previewWebgl, setPreviewWebgl] = useState("");
  const [webGLFound, setWebGLFound] = useState(false);
  const [playModule, setPlayModule] = useState(false);
  const [previewModule, setPreviewModule] = useState(false);
  const [dataLoading, setDataLoading] = useState(true);
  const [previewStarted, setPreviewStarted] = useState(false);
  const [activeCarausel, setActiveCarausel] = useState('webGL');
  const [activeMediaIndex, setActiveMediaIndex] = useState(null);

  const getWebGlPlayLink = async () => {
    setWebGLFound(false)
    try {
      const loginType = isLoggedIn ? "postlogin" : "prelogin";
      const response = await axios.get(`${configData.config.UNO_URL}/api/user/play/module/${loginType}/${moduleUUID}`, {
        params:{
          applicationId: configData.config.applicationId
        },
        headers: {
          Authorization: `Bearer ${userData.token}`,
        }
      });
      setDataLoading(false);
      setWebGlFile(response?.data?.embed || "");
      setWebGLFound(response?.data?.embed ? true : false)
      setPreviewWebgl(response?.data?.embed || "");
    } catch (error) {
      console.log(error);
    }
  }

  const handleContextMenu = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    // if (moduleUUID.length && userData.user.permissions.includes("XR.DASHBOARD.PLAYCOURSE")) {
    if (moduleUUID.length > 0) {
      getWebGlPlayLink();
    }
  }, [moduleUUID, userData])

  const callFunctionInReact = () => {
    if (document.fullscreenElement === iframeRef.current) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }

    }
  };

  const loadingCompleteHandleMessage = (event) => {
    if (event.source === iframeRef?.current?.contentWindow) {
      if (event.data === 'ASSET_DOWNLOADED') {
        if (previewModule && !previewStarted) {
          setTimeout(() => {
            setPreviewModule(false);
            setPlayModule(false);
            setPreviewWebgl("");
            setPreviewStarted(true);
          }, previewTime * 1000);
        }
      }
    }
  };

  useEffect(() => {
    setTimeout(() => {
      window.addEventListener('message', loadingCompleteHandleMessage);
      return () => window.removeEventListener('message', loadingCompleteHandleMessage);
    }, [100]);
  }, [previewModule]);

  let [launcher, setLauncher] = useState("");
  let [launcherOculus, setLauncherOculus] = useState("");
  let [launcherApk, setLauncherApk] = useState("");

  const handleDownload = async () => {
    try {
      let channelId = configData?.config?.channel?.uuid || "";

      const {data} = await axios.get(`${configData.config.UNO_URL}/api/application/launcher/latest-version/${configData.config.applicationId}?channelId=${channelId}`);
      setLauncher(data.data.windows);
      setLauncherApk(data.data.android);
      setLauncherOculus(data.data.oculus);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    handleDownload();
  }, []);

  const playOnline = () => {
    setPlayModule(true);
    setPreviewModule(false);
    setPreviewWebgl(webGlFile)
  }

  const preview = () => {
    setPreviewModule(true);
    setPlayModule(false);
    setPreviewWebgl(webGlFile);
  }

  let webFileAvailable = availablePlatform.some(e => e.name == "Online");
  let availablePlatformList = availablePlatform.filter(e => e.name !== "Online");
  
  return (
    <>

      <div className="module-frame container position-relative">
        <div className="playscreen ps-0" >
           
          {dataLoading ?
            <div className='frame-parent' >
              <div className='frame-details'>
                <div className="loader">
                  <div className="cube">
                    <div className="face"></div>
                    <div className="face"></div>
                    <div className="face"></div>
                    <div className="face"></div>
                    <div className="face"></div>
                    <div className="face"></div>
                  </div>
                </div>
              </div>
            </div>
            :
            <>
              {
                activeCarausel === 'webGL' ?
                  webGLFound ?
                  <>
           
                      {(playModule || previewModule) ?
                        <div className='frame-parent'>
                          <iframe title="play" ref={iframeRef} className="w-100 h-100" src={previewWebgl} width="100%" allowFullScreen />
                        </div>
                        :
                        <div className='frame-parent'>
                          <div className={moduleDetails?.versions[0]?.data?.thumbnail ? "playscreen-frame" : "playscreen-frame no-bg" } style={{ backgroundImage: `url("${moduleDetails?.versions[0]?.data?.thumbnail ? moduleDetails.versions[0].data.thumbnail : defaultLogo}")` }}>
                            <div className="black-overlay"></div>
                            <div className='frame-details'>
                              <h5 id="name">{moduleDetails.name} </h5>
                            
                              <p id="description" className='info-here'>
                                {moduleDetails?.versions[0]?.data?.short}
                              </p>
                            
                              {/* {(webFileAvailable && userData.user.permissions.includes("XR.DASHBOARD.PLAYCOURSE")) && */}
                              {webFileAvailable &&
                                <div className='frame-btns mt-4'>
                                  {(isLoggedIn && assignedToUser) ?
                                    <button id="plybtn" onClick={playOnline} >Play Online</button>
                                    :
                                    <button id="previewbtn" className="previewbtn" onClick={() => preview()} >Preview</button>
                                  }
                                </div>
                              }

                              {availablePlatformList.length &&
                                <div id="launcher-apps" className='launcher-promo'>
                                  Currently available across:
                                  <span>
                                    
                                    {availablePlatformList.map((e, f) => {
                                      let iconSrc = "", downloadLink, helpText;
                                      switch (e.name) {
                                        case "Desktop":
                                          helpText = "Desktop";
                                          iconSrc = WindowsIcon;
                                          downloadLink = launcher;
                                          break;
                                        case "Desktop VR":
                                          helpText = "Desktop VR";
                                          iconSrc = DesktopVRIcon;
                                          downloadLink = launcher;
                                          break;
                                        case "Standalone VR":
                                          helpText = "Standalone VR";
                                          iconSrc = StandaloneVRIcon;
                                          downloadLink = launcherOculus;
                                          break;
                                        case "Mobile":
                                          helpText = "Mobile";
                                          iconSrc = AndroidIcon;
                                          downloadLink = launcherApk;
                                          break;
                                        default:
                                          break;
                                      }

                                      return (
                                        <a href={downloadLink} download key={f}>
                                          <Tooltip title={helpText}>
                                            <img src={iconSrc} alt={helpText} />
                                          </Tooltip>
                                        </a>
                                      );
                                    })}

                                  </span>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      }
                    </>
                    :
                    <div className='frame-parent'>
                     <div className={moduleDetails?.versions[0]?.data?.thumbnail ? "playscreen-frame" : "playscreen-frame no-bg" } style={{ backgroundImage: `url("${moduleDetails?.versions[0]?.data?.thumbnail ? moduleDetails.versions[0].data.thumbnail : defaultLogo}")` }}>
                        <div className="black-overlay"></div>
                        <div className='frame-details'>
                          <h5 id="name">{moduleDetails.name} </h5>
                          <p id="description" className='info-here'>
                            {moduleDetails?.versions[0]?.data?.short}
                          </p>
                        {availablePlatform.length &&
                                <div id="launcher-apps" className='launcher-promo'>
                                  Currently available across:
                                  <span>
                                    {availablePlatform.map((e, f) => {
                                      let iconSrc = "", downloadLink, helpText;
                                      switch (e.name) {
                                        case "Desktop":
                                          helpText = "Desktop";
                                          iconSrc = WindowsIcon;
                                          downloadLink = launcher;
                                          break;
                                        case "Desktop VR":
                                          helpText = "Desktop VR";
                                          iconSrc = DesktopVRIcon;
                                          downloadLink = launcher;
                                          break;
                                        case "Standalone VR":
                                          helpText = "Standalone VR";
                                          iconSrc = StandaloneVRIcon;
                                          downloadLink = launcherOculus;
                                          break;
                                        case "Mobile":
                                          helpText = "Mobile";
                                          iconSrc = AndroidIcon;
                                          downloadLink = launcherApk;
                                          break;
                                        default:
                                          break;
                                      }
                                      return (
                                        <a href={downloadLink} download key={f}>
                                          <Tooltip title={helpText}>
                                            <img src={iconSrc} alt={helpText} />
                                          </Tooltip>
                                        </a>
                                      );
                                    })}
                                  </span>
                                </div>
                              }
                        </div>
                      </div>
                    </div>
                  :

                  activeCarausel === 'media' && moduleDetails.versions[0].data.media.length > 0 &&
                  <div className='frame-parent' onContextMenu={handleContextMenu}>
                    {moduleDetails.versions[0].data.media[activeMediaIndex] && moduleDetails.versions[0].data.media[activeMediaIndex].url &&
                      (
                        moduleDetails.versions[0].data.media[activeMediaIndex].url.endsWith('.jpg') || 
                        moduleDetails.versions[0].data.media[activeMediaIndex].url.endsWith('.png') || 
                        moduleDetails.versions[0].data.media[activeMediaIndex].url.endsWith('.jpeg') 
                      ) ? 
                      <img src={moduleDetails.versions[0].data.media[activeMediaIndex].url} className="d-block w-100" alt="..." /> 
                      : 
                      (
                        moduleDetails.versions[0].data.media[activeMediaIndex].url && 
                        moduleDetails.versions[0].data.media[activeMediaIndex].url.endsWith('.mp4')
                      ) &&
                      <Player>
                        <source src={moduleDetails.versions[0].data.media[activeMediaIndex].url} />
                        <BigPlayButton position="center" />
                      </Player>
                    }
                  </div>
              }
            </>
          }

          <div className="moduleslideDots">
            {
              moduleDetails?.versions[0]?.data?.media?.length > 0 && (
                <>
                
                  <div className= { activeCarausel == 'webGL' ? "webglicon active" :  "webglicon "} >
                    <span onClick={() => setActiveCarausel('webGL')}>
                      <img src={webgl} alt="Webgl play" />
                    </span>
                  </div>

                  {moduleDetails.versions[0].data.media.map((element, index) => (
                    <div className={ activeCarausel == 'media' ? activeMediaIndex == index ? "imagesicon active" : "imagesicon" : "imagesicon" } key={index}>
                      <span onClick={() => { setActiveCarausel('media'); setActiveMediaIndex(index); }}>
                        <CircleOutlinedIcon />
                      </span>
                    </div>
                  ))}

                </>
              )
            }

          </div>
        </div>

        <div className='module-info'>
          <div className='info-body'>
            <div className='info-name'>
              <p> {moduleDetails.name} </p>
              <span>This module is available across {availablePlatform.length} platforms</span>
            </div>
            <div className='info-platforms'>
              <p>Available Platforms</p>
              <span className='diff-plat'>
                {availablePlatform.map((e, f) => {
                  return (
                    <span key={f} onClick={() => window.open("https://cdn.simulanis.io/unity/NSC2/index.html", "_blank")}>
                      <span> <img src={platformIcon[e.name]}  /></span>
                      {e.name}
                    </span>
                  )
                }
                )}
              </span>
            </div>

            <div className='info-any'>
              <p>In-build Analytics</p>
              <span>Integrated wth deep analytics</span>
            </div>

            <div className='info-any'>
              <p> {`${courseDuration} Minutes`}</p>
              <span>Learn at your own pace</span>
            </div>

            <div className='info-any info-rate'>
              <p>Hands on Learning</p>
              <span>
                {Number.isInteger(average) ? average : average.toFixed(1)} <StarIcon /> ({`${totalReviews} Reviews`} )
              </span>
            </div>

          </div>

          <div className="detail-btn" onClick={handleSetToAbout}>
            View Details
          </div>
        </div>
      </div>

    </>
  );
};

export default PlayComp;
